<template>
  <div class="legend">
    <b-form-checkbox
      class="large-checkbox inline-block mx-3"
      v-model="showExpTier"
    >
      <p class="mx-2">
        <span class="mx-2 legend-text">{{ $t('legends.expTier') }}</span>
        <span class="legend-icon tier tier-exp">S</span>
        <span class="legend-icon tier tier-exp">A</span>
        <span class="legend-icon tier tier-exp">B</span>
        <span class="legend-icon tier tier-exp">C</span>
        <span class="legend-icon tier tier-exp">D</span>
        <span class="legend-icon tier tier-exp">F</span>
      </p>
    </b-form-checkbox>
    <b-form-checkbox
      class="large-checkbox inline-block mx-3"
      v-model="showLootTier"
    >
      <p class="mx-2">
        <span class="mx-2 legend-text">{{ $t('legends.lootTier') }}</span>
        <span class="legend-icon tier tier-loot">S</span>
        <span class="legend-icon tier tier-loot">A</span>
        <span class="legend-icon tier tier-loot">B</span>
        <span class="legend-icon tier tier-loot">C</span>
        <span class="legend-icon tier tier-loot">D</span>
        <span class="legend-icon tier tier-loot">F</span>
      </p>
    </b-form-checkbox>
    <b-form-checkbox
      class="large-checkbox inline-block mx-3"
      v-model="showImmunities"
    >
      <p class="mx-2">
        <span class="mx-2 legend-text">{{ $t('legends.immunities') }}</span>
        <span class="legend-icon immunities">
          <img alt="Immunity to fire" src="../assets/fire.svg">
        </span>
        <span class="legend-icon immunities">
          <img alt="Immunity to fire" src="../assets/snow.svg">
        </span>
        <span class="legend-icon immunities">
          <img alt="Immunity to fire" src="../assets/lightning.svg">
        </span>
        <span class="legend-icon immunities">
          <img alt="Immunity to fire" src="../assets/skull.svg">
        </span>
        <span class="legend-icon immunities">
          <img alt="Immunity to fire" src="../assets/sword.svg">
        </span>
        <span class="legend-icon immunities">
          <img alt="Immunity to fire" src="../assets/magic.svg">
        </span>
      </p>
    </b-form-checkbox>
  </div>
</template>

<script>

export default {
  name: 'Legends',

  data() {
    return {
      showImmunities: false,
      showExpTier: false,
      showLootTier: false,
    }
  },

  watch: {
    showImmunities(newValue) {
      localStorage.setItem('immunities', newValue);
      this.$emit('change-immunities', newValue);
    },
    showExpTier(newValue) {
      localStorage.setItem('exp_tier', newValue);
      this.$emit('show-exp-tier', newValue);
    },
    showLootTier(newValue) {
      localStorage.setItem('loot_tier', newValue);
      this.$emit('show-loot-tier', newValue);
    },
  },

  created() {
    if (localStorage.getItem('tier')  === 'true') {
      localStorage.setItem('exp_tier', true);
      localStorage.removeItem('tier');
      this.$emit('show-exp-tier', true);
    }
    this.showImmunities = localStorage.getItem('immunities') === 'true';
    this.showExpTier = localStorage.getItem('exp_tier')  === 'true';
    this.showLootTier = localStorage.getItem('loot_tier')  === 'true';
  },
}

</script>

<style>
.legend {
  width: 75%;
  max-width: 900px;
  margin: auto;
}
@media (max-width: 600px) {
  .legend {
    width: 90%;
  }
}
.legend-icon {
  padding-right: .3em;
  padding-left: .3em;
  margin: 0em 0.1em;
  border-radius: 10rem;
}
.legend-text {
  color: #fff;
}
.immunities {
  background-color: #f0f0f0;
}
.immunities img {
  width: 10px;
  height: 10px;
  margin-top: -2px;
}
.tier {
  font-family: monospace;
  font-size: 16px;
  color: #fff;
  background-color: #918a6b;
  cursor: pointer;
}
.tier-exp {
  background-color: #e09100;
}
.tier-loot {
  background-color: #4169e1;
}
.large-checkbox input[type=checkbox] {
    transform: scale(1.5);
}
</style>